import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Subject } from "rxjs/Subject";
import * as _ from 'lodash';
import {
  HttpClient
} from '@angular/common/http';
import { Location } from '@angular/common';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

/**Local file */

import { apiCalls } from '../../../utils/index';
import { SolutionDescriptionNodes, FetchAllSolutionDescription, FetchAllKpiValues, KpiDataSets } from '../../../models';

/**Query file */
import {
  UserQueryService,
  QualityReferenceQueryService,
  PersonalityReferenceQueryService,
  PicStoriesQueryService,
  ScheduleQueryService,
  CompaniesQueryService,
  TestimonialsQueryService,
  SolutionDescriptionQueryService,
  KpiQueryService,
  WCCategoriesQueryService,
  WCSubCategoriesQueryService,
  CommonQueryService
} from '../../../queryFiles/index';
import { promise } from 'selenium-webdriver';

@Injectable()
export class SideNavService implements Resolve<any>
{
  apiCalls = apiCalls;

  onProInfoChanged: BehaviorSubject<any> = new BehaviorSubject({});
  onProInfoSelected: BehaviorSubject<any> = new BehaviorSubject({});
  onProUserInfoTabSelected: BehaviorSubject<any> = new BehaviorSubject({}); //User info tab
  onScheduleRequestChanged: BehaviorSubject<any> = new BehaviorSubject({ loading: true, scheduleRequestOrders: [] }); //User info tab
  onSolutionDatabaseChanged: BehaviorSubject<any> = new BehaviorSubject({ loading: true, solutionDescriptionList: [] });
  onKpiDetailsChanged: BehaviorSubject<any> = new BehaviorSubject({ allKpiList: {} })
  onProBasicInfo: BehaviorSubject<any> = new BehaviorSubject({});
  onProInfoFiltered: Subject<any> = new Subject;

  onSolutionInfo = new BehaviorSubject<boolean>(false);

  scheduleRequestStatus = [];
  solutionDescriptionListByLimit = [];
  filteredSolutionDescription: SolutionDescriptionNodes[] = [];
  routeParams: any;
  lastSubCateId: number;
  lastCateId: number;


  constructor(
    private http: HttpClient,
    private location: Location,
    // Query file
    private userQueryService: UserQueryService,
    private qualityReferenceQueryService: QualityReferenceQueryService,
    private personalityReferenceQueryService: PersonalityReferenceQueryService,
    private picStoriesQueryService: PicStoriesQueryService,
    private scheduleQueryService: ScheduleQueryService,
    private _companiesQueryService: CompaniesQueryService,
    private _testimonialQueryService: TestimonialsQueryService,
    private _solutionDescriptionQueryService: SolutionDescriptionQueryService,
    private _KpiQueryService: KpiQueryService,
    private _wCCategoriesQueryService: WCCategoriesQueryService,
    private _wCSubCategoriesQueryService: WCSubCategoriesQueryService,
    private commonQueryService: CommonQueryService
  ) {
  }

  /**
   * The File Manager App Main Resolver
   * @param {ActivatedRouteSnapshot} route
   * @param {RouterStateSnapshot} state
   * @returns {Observable<any> | Promise<any> | any}
   */
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {

    return new Promise((resolve, reject) => {

      console.log('location path', this.location.path());

      Promise.all([
        this.getFiles()
      ]).then(
        ([files]) => {
          resolve('');
        },
        reject
      );
    });
  }

  /** Get all uploaded files docuemnts */

  getFiles(): Promise<any> {

    let url = this.apiCalls.getUploadDocumentUrls;

    return new Promise((resolve, reject) => {

      this.http.get(url)
        .subscribe((response: any) => {

          this.onProInfoChanged.next(response);
          resolve(response);

        }, reject);

    });
  }

  /**Get single pro user */

  getProUser(id) {
    return new Promise((resolve, reject) => {

      /**Get mail id of this user */
      this.userQueryService.GET_USER_BASED_UID(id)
        .valueChanges
        .subscribe((response: any) => {

          if (response &&
            response.data &&
            response.data.allUsers &&
            response.data.allUsers.edges.length) {


            response.data.allUsers.edges.forEach((user) => {

              this.onProBasicInfo.next(user);
              resolve('success');
            })
          } else {
            reject;
          }
        }, reject)
    })
  }


  /**Fetch Refrences */
  fetchQualityRef(userId) {

    return new Promise((resolve, reject) => {
      this.qualityReferenceQueryService
        .FETCH_REFERENCES(userId)
        .valueChanges
        .subscribe((response: any) => {
          resolve(response);
        }, reject)
    })
  }

  /**Fetch personality Refrences */
  fetchPersonalityRef(userId) {

    return new Promise((resolve, reject) => {
      this.personalityReferenceQueryService
        .FETCH_REFERENCES(userId)
        .valueChanges
        .subscribe((response: any) => {
          resolve(response);
        }, reject)
    })
  }

  /**Fetch Refrences */
  fetchPicStories(userId) {

    return new Promise((resolve, reject) => {
      this.picStoriesQueryService
        .FETCH_PIC_STORIES(userId)
        .valueChanges
        .subscribe((response: any) => {
          resolve(response);
        }, reject)
    })
  }

  /** Get all orders status from ' SchduleRequest' */
  async fetchOrderStatus(from, cursor) {

    this.onScheduleRequestChanged.next({ loading: true });

    return new Promise(async (resolve, reject) => {

      await this.scheduleQueryService.GET_ALL_SCHEDULE_REQUESTS(from, cursor)
        .valueChanges
        .subscribe(async (response: any) => {

          this.scheduleRequestStatus = [];

          if (response && response.data &&
            response.data.allScheduleRequests &&
            response.data.allScheduleRequests.edges.length > 0) {

            var responseData = response.data.allScheduleRequests;
            var responseEdges = responseData.edges;

            responseEdges.forEach((requests, key) => {

              var data = {
                orderId: requests && requests.node.orderId,
                scheduleRequestDate: requests && requests.node.scheduleRequestDate,
                additionalShare: requests && requests.node.additionalShare,
                contactName: requests && requests.node.contactName,
                contactEmail: requests && requests.node.contactEmail,
                contactPhone: requests && requests.node.contactPhone,
                createdAt: requests && requests.node.createdAt,
                buyerProperty: requests && requests.node.buyerProperty,
                insReportId: requests && requests.node && requests.node.scheduleRequestId,
              }

              this.scheduleRequestStatus.push(data);

              if (responseEdges.length == this.scheduleRequestStatus.length) {

                this.scheduleRequestStatus = _.uniqBy(this.scheduleRequestStatus, 'orderId');
                // console.log('data.allScheduleRequests', responseData);

                this.onScheduleRequestChanged.next({
                  loading: false,
                  scheduleRequestOrders: this.scheduleRequestStatus,
                  endCursor: responseData && responseData.pageInfo.endCursor,
                  hasNextPage: responseData && responseData.pageInfo.hasNextPage,
                  from: from
                });
              }
            })

          } else {

            this.onScheduleRequestChanged.next({
              loading: false,
              scheduleRequestOrders: [],
              endCursor: '',
              hasNextPage: false,
              from: from
            });
          }


        }, () => {
          reject;
        })
    })

  }

  // Upload company logo to serve
  fileUpload(payload, fileName: string, from: string) {
    //Without base64 content using formData
    let formData = new FormData();
    formData.append('file', payload);

    return new Promise((resolve, reject) => {

      const url = this.apiCalls.uploadCompanyLogoandTestimonal + '?fileName=' + fileName + '&from=' + from;

      this.http.post(url, formData)
        .subscribe(data => {
          resolve(data);
        }, error => {
          reject(error);
        })
    })
  }

  /** Create referece of company logo to db  */
  CreateCompanyLogoOnDb(fileName: string) {
    // console.log('fileName', fileName);
    return new Promise((resolve, reject) => {

      this._companiesQueryService.UPLOAD_COMPANY_LOGO(fileName)
        .subscribe((res) => {
          resolve(res);
        }, reject);

    });
  }

  /** Create referece of testimonial to db  */
  CreateTestimonialOnDb(fileName: string, quotes: string) {
    // console.log('fileName', fileName);
    return new Promise((resolve, reject) => {

      this._testimonialQueryService.UPLOAD_TESTIMONIAL(fileName, quotes)
        .subscribe((res) => {
          resolve(res);
        }, reject);

    });
  }

  /** Create referece of testimonial to db  */
  CreateSolutionDescriptionOnDb(Solution: SolutionDescriptionNodes) {
    // console.log('fileName', fileName);
    return new Promise((resolve, reject) => {

      this._solutionDescriptionQueryService
        .CREATE_SOLUTION_DESCRIPTION(Solution)
        .subscribe((res) => {
          this.onSolutionInfo.next(true);
          console.log("response", res);
          resolve(res);
        }, reject);

    });
  }

  /** Create kpi  */
  CreateKpiDetails(kpiDataSet: any) {
    // console.log('fileName', fileName);
    return new Promise((resolve, reject) => {

      this._KpiQueryService
        .CREATE_KPI(kpiDataSet)
        .subscribe((res) => {
          resolve(res);
        }, reject);

    });
  }

  /** Update kpi  */
  updateKpiDetailsById(kpiDataSet: any, kpiId: number) {
    // console.log('fileName', fileName);
    return new Promise((resolve, reject) => {

      this._KpiQueryService
        .UPDATE_KPI_DETAILS_BY_ID(kpiDataSet, kpiId)
        .subscribe((res) => {
          console.log("response", res);
          resolve(res);
        }, reject);

    });
  }

  /**Fetch company logo id  */
  fetchAllKpiData() {

    return new Promise((resolve, reject) => {
      this._KpiQueryService
        .GET_ALL_KPI_DETAILS()
        .valueChanges
        .subscribe((response: FetchAllKpiValues) => {
          var res = response && response.data && response.data.allKpis && response.data.allKpis.nodes;
          console.log("all kpis", res, response);
          if (res) {
            if (res.length == 0) {
              console.log("lenth 0");
              var allDetails: KpiDataSets[] = [];
              this.onKpiDetailsChanged.next({
                allKpiList: allDetails,
                kpiId: null,
                lastEdited: null
              });
            } else {
              _.each(res, (details) => {
                var allDetails: KpiDataSets[] = [];
                allDetails = JSON.parse(details.kpiDetails.toString());
                this.onKpiDetailsChanged.next({
                  allKpiList: allDetails,
                  kpiId: details.id,
                  lastEdited: details.createdAt
                });
              });
            }

          }
          resolve(response);
        }, reject)
    })
  }

  /** Create referece of testimonial to db  */
  updateSolutionDescriptionByIdOnDb(Solution: SolutionDescriptionNodes) {
    // console.log('fileName', fileName);
    return new Promise((resolve, reject) => {

      this._solutionDescriptionQueryService
        .UPDATE_SOLUTION_DESCRIPTION(Solution)
        .subscribe((res) => {
          resolve(res);
        }, reject);

    });
  }

  /**Fetch company logo id  */
  fetchAllCompanyLogo() {

    return new Promise((resolve, reject) => {
      this._companiesQueryService
        .GET_ALL_COMPANY_LOGO()
        .valueChanges
        .subscribe((response: any) => {
          resolve(response);
        }, reject)
    })
  }

  /**Fetch testimonial datas  */
  fetchAllTestimonial() {

    return new Promise((resolve, reject) => {
      this._testimonialQueryService
        .GET_ALL_TESTIMONIAL()
        .valueChanges
        .subscribe((response: any) => {
          resolve(response);
        }, reject)
    })
  }

  fetchingSolutionDescriptionByFilter(solutions: any) {
    return new Promise((resolve, reject) => {
      let searchResult = null;
      if (solutions.key1 || solutions.key2 || solutions.key3 || solutions.key4 || solutions.keyPrimCategory && solutions.subcategory) {
        searchResult = this._solutionDescriptionQueryService
          .GET_SOLUTION_DESCRIPTION_BY_FILTER_OPTION(solutions)
          .valueChanges
      }
      else {
        searchResult = this._solutionDescriptionQueryService
          .GET_PRIMARY_SOLUTION_BY_FILTER_OPTION(solutions)
          .valueChanges;
      }

      if (searchResult) {
        searchResult.subscribe((response: any) => {
          this.filteredSolutionDescription = [];
          if (response && response.data &&
            response.data.allSolutionDescriptions &&
            response.data.allSolutionDescriptions.nodes.length > 0) {

            response.data.allSolutionDescriptions.nodes.forEach((solutions) => {
              var newSolutions = {
                id: solutions && solutions.id,
                solution: solutions && solutions.solution,
                cost: solutions && solutions.cost,
                keyword: solutions && solutions.keyword,
                keyPrimCategory: solutions && solutions.keyPrimCategory,
                subcategory: solutions && solutions.subcategory,
                key1: solutions && solutions.key1,
                keyPhrase: solutions && solutions.keyPhrase,
                key2: solutions && solutions.key2,
                key3: solutions && solutions.key3,
                key4: solutions && solutions.key4,
                costOption: solutions && solutions.costOption,
                labourCost: solutions && solutions.labourCost,
                hourRate: solutions && solutions.hourRate,
                laborHour: solutions && solutions.laborHour,
                materialCost: solutions && solutions.materialCost,
                ni: solutions && solutions.ni,
                tf: solutions && solutions.tf,
                cpi: solutions && solutions.cpi,
                cpf: solutions && solutions.cpf,
                totalCost: solutions && solutions.totalCost,
                irl: solutions && solutions.irl,
              }
              this.filteredSolutionDescription.push(newSolutions);
            });


          } else {
            this.filteredSolutionDescription = [];
          }
          resolve(this.filteredSolutionDescription);
        }, reject)
      }
    })
  }

  searchIsTheKeywordPresent(word: string) {
    return new Promise((resolve, reject) => {
      this._solutionDescriptionQueryService
        .CHECK_SEARCH_KEYWORD_IS_PRESENT(word)
        .valueChanges
        .subscribe((response: any) => {
          resolve(response);
        }, reject)
    })
  }

  gettingSuggesstionsWords(word: string, type: string) {
    return new Promise((resolve, reject) => {
      this._solutionDescriptionQueryService
        .GET_WORD_SUGGESSTIONS_BY_FILTER_OPTION(word, type)
        .valueChanges
        .subscribe((response: any) => {
          resolve(response.data.wordSuggestions);
        }, reject)
    })
  }

  checkSolutionDescriptionExited(solutions: any) {
    return new Promise((resolve, reject) => {
      this._solutionDescriptionQueryService
        .CHECK_SOLUTION_DESCRIPTION_EXISTED(solutions)
        .valueChanges
        .subscribe((response: any) => {
          this.filteredSolutionDescription = [];
          if (response && response.data &&
            response.data.allSolutionDescriptions &&
            response.data.allSolutionDescriptions.nodes.length > 0) {

            response.data.allSolutionDescriptions.nodes.forEach((solutions) => {
              var newSolutions = {
                id: solutions && solutions.id,
              }
              this.filteredSolutionDescription.push(newSolutions);
            });
          } else {
            this.filteredSolutionDescription = [];
          }
          resolve(this.filteredSolutionDescription);
        }, reject)
    })
  }

  async fetchAllSolutionDescriptionsByLimit(from, cursor) {

    this.onSolutionDatabaseChanged.next({ loading: true });

    return new Promise(async (resolve, reject) => {
      await this._solutionDescriptionQueryService
        .GET_SOLUTION_DESCRIPTION_BY_LIMIT(from, cursor)
        .valueChanges
        .subscribe((response: any) => {
          this.solutionDescriptionListByLimit = [];
          if (response && response.data &&
            response.data.allSolutionDescriptions &&
            response.data.allSolutionDescriptions.edges.length > 0) {

            var responseData = response.data.allSolutionDescriptions;
            var responseEdges = responseData.edges;

            responseEdges.forEach((solutions, key) => {

              var data = {
                id: solutions && solutions.node.id,
                solution: solutions && solutions.node.solution,
                cost: solutions && solutions.node.cost,
                keyword: solutions && solutions.node.keyword,
                keyPrimCategory: solutions && solutions.node.keyPrimCategory,
                subcategory: solutions && solutions.node && solutions.node.subcategory,
                key1: solutions && solutions.node.key1,
                keyPhrase: solutions && solutions.node.keyPhrase,
                key2: solutions && solutions.node.key2,
                key3: solutions && solutions.node.key3,
                key4: solutions && solutions.node.key4,
                costOption: solutions && solutions.node.costOption,
                labourCost: solutions && solutions.node.labourCost,
                hourRate: solutions && solutions.node.hourRate,
                laborHour: solutions && solutions.node.laborHour,
                materialCost: solutions && solutions.node.materialCost,
                ni: solutions && solutions.node.ni,
                tf: solutions && solutions.node.tf,
                cpi: solutions && solutions.node.cpi,
                cpf: solutions && solutions.node.cpf,
                totalCost: solutions && solutions.node.totalCost,
                irl: solutions && solutions.node.irl,
              }

              this.solutionDescriptionListByLimit.push(data);

              if (responseEdges.length == this.solutionDescriptionListByLimit.length) {

                this.solutionDescriptionListByLimit = _.uniqBy(this.solutionDescriptionListByLimit, 'id');
                // console.log('data.allScheduleRequests', responseData);

                this.onSolutionDatabaseChanged.next({
                  loading: false,
                  solutionDescriptionList: this.solutionDescriptionListByLimit,
                  endCursor: responseData && responseData.pageInfo.endCursor,
                  hasNextPage: responseData && responseData.pageInfo.hasNextPage,
                  from: from,
                  totalCount: response.totalCount
                });
              }
            })

          } else {

            this.onSolutionDatabaseChanged.next({
              loading: false,
              solutionDescriptionList: [],
              endCursor: '',
              hasNextPage: false,
              from: from,
              totalCount: 0
            });
          }
          resolve(response);
        }, reject)
    })
  }


  /**Delete company by id  */
  deleteSelectedCompanyLogoData(id: number) {
    return new Promise((resolve, reject) => {
      this._companiesQueryService
        .DELETE_COMPANY_LOGO(id)
        .subscribe((response: any) => {
          resolve(response);
        }, reject)
    })
  }

  /**Delete testimonial by id  */
  deleteSelectedTestimonialData(id: number) {
    return new Promise((resolve, reject) => {
      this._testimonialQueryService
        .DELETE_TESTIMONIAL(id)
        .subscribe((response: any) => {
          resolve(response);
        }, reject)
    })
  }

  /**Delete testimonial by id  */
  deleteSolutionDescriptionByIdOnDb(id: number) {
    return new Promise((resolve, reject) => {
      this._solutionDescriptionQueryService
        .DELETE_SOLUTION_DESCRIPTION(id)
        .subscribe((response: any) => {
          resolve(response);
        }, reject)
    })
  }

  getAllCategories() {

    return new Promise((resolve, reject) => {
      this._wCCategoriesQueryService
        .GET_WC_CATEGORIES().valueChanges
        .subscribe((response: any) => {
          resolve(response);
        }, reject)
    })
  }

  searchPrimaryCategories(searchCategory) {

    return new Promise((resolve, reject) => {
      this._wCCategoriesQueryService
        .SEARCH_WC_CATEGORIES(searchCategory).valueChanges
        .subscribe((response: any) => {
          resolve(response);
        }, reject)
    })
  }
  searchSubCategories(searchCategory) {

    return new Promise((resolve, reject) => {
      this._wCCategoriesQueryService
        .SEARCH_WC_CATEGORIES(searchCategory).valueChanges
        .subscribe((response: any) => {
          resolve(response);
        }, reject)
    })
  }






  createSubCategory(categoryId, subCategoryValue) {
    let subCategory = subCategoryValue.trim();
    var params = {
      subcategory: subCategory,
      categoryid: categoryId,
    }
    return new Promise((resolve, reject) => {
      this._wCSubCategoriesQueryService.CREATE_WC_SUB_CATEGORIES(params)
        .subscribe((result) => {
          resolve(result);
        }, reject)
    });
  }



  createPrimaryCategory(category) {
    //Db value store check or without case checking or db query is worng
    let primeCategory = category.toUpperCase();// want remove 
    var params = {
      category: primeCategory,
    }
    return new Promise((resolve, reject) => {

      this._wCCategoriesQueryService.CREATE_WC_CATEGORIES(params)
        .subscribe((result) => {
          resolve(result)
        }, reject);
    })
  }

  getAllSubCategories(categoryId) {
    return new Promise((resolve, reject) => {
      this._wCSubCategoriesQueryService
        .GET_ALL_SUB_CATEGORIES_BY_CATEGORYID(categoryId).valueChanges
        .subscribe((response: any) => {

          resolve(response);
        }, reject)
    })
  }
  getLastCategoryId() {
    return new Promise((resolve, reject) => {
      this._wCCategoriesQueryService
        .GET_LAST_WC_CATEGORY_ID().valueChanges
        .subscribe((response: any) => {

          resolve(response);
        }, reject)
    })
  }

  EDIT_ORDER_NEW(nodeId, orderDetails) {
    return new Promise(async (resolve, reject) => {
      //update the aricve status in db
      await this.commonQueryService.EDIT_ORDER_NEW_FIELDS(nodeId, orderDetails).subscribe((result: any) => {
        console.log('updated new fields **', result);
        resolve('success');
      }, error => {
        reject(error);
      });
    });
  }


  /** Get all orders*/
  GetAllOrders(payload) {
    return new Promise((resolve, reject) => {
      this.commonQueryService
        .GET_ALL_ORDERS_DB(payload)
        .subscribe((res: any) => {
          var responseData = res.data &&
            res.data.allOrders && res.data.allOrders.nodes;
          var totalCount = res.data &&
            res.data.allOrders && res.data.allOrders.totalCount;

          let tempObj = {
            data: responseData,
            totalCount: totalCount
          }
          resolve(tempObj);
        }, err => {
          reject(err);
        });
    });
  }

  async getOrders() {
    return await new Promise(async (resolve, reject) => {
      // if (response.version == "PROD") {
      let orders = [];
      let offset = 0;
      let calls = 0;
      do {
        let payload = {
          offset: offset,
          first: 100
        };
        console.log("payload:", payload, "calls", calls + 1)

        await this.commonQueryService
          .GET_ALL_ORDERS_DB(payload).subscribe((ordersRes: any) => {
            console.log(ordersRes, 'ordersRes')
            if (ordersRes.data &&
              ordersRes.data.allOrders && ordersRes.data.allOrders.nodes && ordersRes.data.allOrders.nodes.length > 0) {
              orders = orders.concat(ordersRes.data.allOrders.nodes);
              offset = offset + 100;
              calls = calls + 1;
            } else {
              offset = null;
              console.log(orders, 'final orders');
            }
          }, (orderError) => {
            reject({
              patient: 0,
              error: orderError,
              status: 'failed'
            });
          });
      } while (offset != null)
      // } else {
      //     resolve({
      //         patient: contacts.patientsContactsEtvs,
      //         totalCount: contacts.patientsContactsEtvs.length,
      //         status: 'success'
      //     });
      // }
    })
  }
}



// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/orders/sidenavs/sidenav.service.ts